import ResponsiveContainer from './ResponsiveContainer';

export default ResponsiveContainer;